import attachFileIcon from '../images/attach-file-icon.svg'
import deleteIcon from '../images/delete-icon.svg'
import ScholarshipStatusSelector from './ScholarshipStatusSelector';

interface ProgressRecordProps {
    isCompleted: boolean;
    scholarshipStatusId?: number;
    note: string;
    files: File[];
    filesDescription: string[];
    filesFromServer: { fileNo: number, fileName: string, fileDesc: string }[];
    setIsCompleted: (value: boolean) => void;
    setScholarshipStatusId?: (value: number) => void;
    handleOnNoteChange: any;
    handleOnFileChange: any;
    handleOnFileDelete: any;
    handleOnDeleteFileFromServer: any;
    handleOnDownloadFileFromServer: any;
    handleOnFileDescriptionChange: any;
    handleOnFileFromServerDescriptionChange?: any;
    isScholarship: boolean;
    loading?: boolean;
}

export default function ProgressRecord({ note, handleOnNoteChange, files, filesDescription, filesFromServer, handleOnFileChange, handleOnFileDelete, handleOnDeleteFileFromServer, handleOnDownloadFileFromServer, handleOnFileDescriptionChange, handleOnFileFromServerDescriptionChange, isCompleted, scholarshipStatusId, setIsCompleted, setScholarshipStatusId, isScholarship, loading }: ProgressRecordProps) {

    return (
        <div className="ProgressDialog-record-container">
            <div className='flex-center-between'>
                <label htmlFor="note" className='label'>NOTE:</label>
                { !isCompleted && <label className='label'>({note?.length || 0}/500)</label> }
            </div>
            {
                isCompleted ? (
                    <div className="ProgressDialog-note-container" >
                        <p>{note}</p>
                    </div>
                ) : (
                    <textarea name="note" id="note" className="ProgressDialog-note" maxLength={500} value={note || ''} onChange={handleOnNoteChange} disabled={loading}></textarea>
                )
            }
            <div className="ProgressDialog-actions-container">
                <input type="file" multiple id="file" className="ProgressDialog-file" style={{ display: 'none' }} onChange={handleOnFileChange} disabled={loading}/>
                <div>
                    {
                        !isCompleted && (
                            <label htmlFor="file" className="ProgressDialog-upload-file">
                                <img src={attachFileIcon} alt="attachFileIcon" />
                                <span style={{ color: '#626262', fontSize: '0.875rem' }}>Add File</span>
                            </label>
                        )
                    }

                </div>
                {(isScholarship && scholarshipStatusId && setScholarshipStatusId) ? (
                    <ScholarshipStatusSelector scholarshipStatusId={scholarshipStatusId} setScholarshipStatusId={setScholarshipStatusId} setIsCompleted={setIsCompleted} loading={loading}/>
                ) : (
                    <div className="flex gap-dot5" style={{ fontFamily: 'Roboto', fontSize: '0.75rem', fontWeight: '300', alignItems: 'center' }}>
                        <p style={{ marginLeft: 'auto', paddingLeft: '0.5rem', userSelect: 'none', whiteSpace: 'nowrap' }}>Is this goal completed?</p>
                        <label className="switch">
                            <input type="checkbox" checked={isCompleted} onChange={(e) => setIsCompleted(e.target.checked)} disabled={loading}/>
                            <span className="slider round"></span>
                        </label>
                    </div>
                )}
            </div>
            <div className="ProgressDialog-file-list">
                {
                    filesFromServer?.map(({ fileNo, fileName, fileDesc }) => (
                        <div className="ProgressDialog-file-item" key={fileNo}>
                            <img src={attachFileIcon} alt="fileIcon" />
                            <div className="ProgressDialog-file-detail">
                                <a className="ProgressDialog-file-name" onClick={() => handleOnDownloadFileFromServer(fileNo)} title="Click to download file">{fileName}</a>
                                {
                                    !isCompleted ? (
                                        <input type="text"
                                            className="ProgressDialog-file-desc-input"
                                            placeholder="File Description"
                                            spellCheck='false'
                                            value={fileDesc || ''}
                                            onChange={(e) => handleOnFileFromServerDescriptionChange(e, fileNo)}
                                            disabled={loading}
                                        />
                                    ) : (
                                        fileDesc &&
                                        <p className="ProgressDialog-file-desc">{fileDesc}</p>
                                    )
                                }
                            </div>
                            {
                                !isCompleted && (
                                    <div className='flex gap-dot25'>
                                        <button className='ProgressDialog-delete-file-btn' onClick={() => handleOnDeleteFileFromServer(fileNo)} title="Click to delete file" disabled={loading}>
                                            <img src={deleteIcon} alt="deleteIcon" />
                                        </button>
                                    </div>
                                )
                            }
                        </div>
                    ))

                }
                {
                    files.map((file, index) => (
                        <div className="ProgressDialog-file-item" key={`file-item-${file.name}-${file.lastModified}`}>
                            <img src={attachFileIcon} alt="fileIcon" />
                            <div className="ProgressDialog-file-detail">
                                <a className="ProgressDialog-file-name" href={URL.createObjectURL(file)} target="_blank" title="Click to download file">{file.name}</a>
                                {
                                    !isCompleted ? (
                                        <input type="text"
                                            className="ProgressDialog-file-desc-input"
                                            placeholder="File Description"
                                            spellCheck='false'
                                            value={filesDescription[index]}
                                            onChange={(e) => handleOnFileDescriptionChange(e, index)}
                                            disabled={loading}
                                        />
                                    ) : (
                                        filesDescription[index] &&
                                        <p className="ProgressDialog-file-desc">{filesDescription[index]}</p>
                                    )
                                }
                            </div>
                            {
                                !isCompleted && (
                                    <div className='flex gap-dot25'>
                                        <button className='ProgressDialog-delete-file-btn' onClick={() => handleOnFileDelete(index)} title="Click to delete file" disabled={loading}>
                                            <img src={deleteIcon} alt="deleteIcon" />
                                        </button>
                                    </div>
                                )
                            }
                        </div>
                    ))
                }
            </div>
        </div>
    )
}